export default { 
  LOGOUT_WIDTH: 64,
  VERTICAL_MENU_WIDTH: 295,
  MAIN_APP_BAR_HEIGHT: 138,
  BACKGROUND_UPLOAD_WIDHT: 134,

  /*Editor*/
  APP_BAR_HEIGHT: 63,
  COMMAND_BAR_HEIGHT: 45,
  TOOL_BAR_WIDTH: 73,
  PICKER_BOX_WIDTH: 263,

  SELECT_DESCRIBE: 622,

  /*Brand Library Editor*/
  BRAND_ITEM_WIDTH: 150,
  BRAND_ITEM_HEIGHT: 109,
}